// src/infrastructure/providers/backendRegistry.ts

import { firebaseAuthService } from "@infrastructure/firebase/firebaseAuthService";
import { firebaseDatabaseService } from "@infrastructure/firebase/firebaseDatabaseService";
import { firebaseFunctionsService } from "@infrastructure/firebase/firebaseFunctionsService";
import { firebaseStorageService } from "@infrastructure/firebase/firebaseStorageService";
import type {
  AuthService,
  DatabaseService,
  FunctionsService,
  StorageService,
} from "@infrastructure/interfaces/database.interface";

export interface BackendServices {
  database: DatabaseService;
  storage: StorageService;
  functions: FunctionsService;
  auth: AuthService;
}

/**
 * Creates backend registry.
 * Currently only Firebase is implemented.
 */
export function createBackendRegistry(registry: "firebase" = "firebase"): BackendServices {
  switch (registry) {
    case "firebase":
      return {
        database: firebaseDatabaseService,
        storage: firebaseStorageService,
        functions: firebaseFunctionsService,
        auth: firebaseAuthService,
      };
    default:
      return {
        database: firebaseDatabaseService,
        storage: firebaseStorageService,
        functions: firebaseFunctionsService,
        auth: firebaseAuthService,
      };
  }
}

// Singleton instance - import this in your services
export const backendRegistry = createBackendRegistry();

// also for backwards compatibility
export default backendRegistry;
